import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_UTILITY_METABASE_CHART_LOAD_IFRAME_URLS } from 'api/utilityActionTypes';

import requestUtilityApi from 'client/actions/requestUtilityApi';
import SrBox from 'client/components/SrBox';
import './UPMetabaseCharts.less';

const UPMetabaseCharts = ({ charts, dispatch }) => {
  const [loadedMetabaseCharts, setLoadedMetabaseCharts] = useState(null);

  useEffect(() => {
    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_METABASE_CHART_LOAD_IFRAME_URLS,
      payload: {
        metabaseChartIds: charts.map(({ id }) => id),
      },
    }).then((metabaseChartIframes) => {
      setLoadedMetabaseCharts(metabaseChartIframes);
    });
  }, [charts, dispatch]);

  if (!loadedMetabaseCharts) {
    return <div className="loading-ellipses" />;
  }

  return (
    <div className="UPMetabaseCharts" styleName="reportsContainer">
      {loadedMetabaseCharts.map(({ iframeUrl, chart }, index) => (
        <SrBox key={iframeUrl} paddingBottom="10px" width={chart.width} height={chart.height}>
          <iframe
            styleName="reportIframe"
            title={`Report #${index}`}
            width="100%"
            height="100%"
            src={iframeUrl}
          />
        </SrBox>
      ))}
    </div>
  );
};

UPMetabaseCharts.propTypes = {
  charts: PropTypes.array.isRequired,
};

UPMetabaseCharts.displayName = 'UPMetabaseCharts';

export default UPMetabaseCharts;
